import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import { message, Tooltip } from "antd";
import styled from "@emotion/styled"
import { SoundRecognizer } from "../components/SoundRecognizer";
import AudioRecorder from "../components/AudioRecorder/AudioRecorder"
import { useSelector } from "react-redux"
import { ASRDescribeData } from '../components/staticDescribeData';
import Login from "../components/Login/Login";
import Describe from '../components/Describe/Describe';
import TabbedContent from '../components/Tabs';
import BigFileDragger from '../components/Dragger/bigFileDragger';
import { DownloadOutlined } from '@ant-design/icons';
import SensitiveDataConsent from '../components/SensitiveDataConsent';

const W3CWebSocket = require('websocket').w3cwebsocket;

const PlayerStatus = {
  start: '立即转换',
  done: '已转换',
  running: '转换中',
  stop: '停止播放',
  resume: '继续播放',
  replay: '重播',
}


export default function ASR() {
  const token = Cookies.get('access_token')
  const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
  const login = useSelector((state: any) => state?.guard?.isLogin);
  const minorMode = useSelector((state: any) => state?.guard?.minorMode);
  const [messageApi, contextHolder] = message.useMessage();
  const [btnText, setBtnText] = useState<string>(PlayerStatus.start)
  const [recordBase64Audio, setRecordBase64Audio] = useState('');
  const [input, setInput] = useState('')
  const [sensitiveConsent, setSensitiveConsent] = useState(false)
  const socketUrl = `wss://aibook-api.mthreads.com:62220/api/v1/asr?token=${token}`

  const isTabs = useSelector((state: { library: { isTabs: string } }) => state?.library?.isTabs)
  let result = ''
  let asrWS = null
  const clientRef = useRef(null)

  useEffect(() => {
    setIsLogin(!!Cookies.get('access_token'))
  }, [])
  useEffect(() => {
    setIsLogin(!!Cookies.get('access_token'))
  }, [login])
  const HandleAudioRecorded = (base64Data: string) => {
    setRecordBase64Audio(base64Data);
    setBtnText(PlayerStatus.start);
  }

  const openWebSocket = () => {
    if ("WebSocket" in window) {
      asrWS = new W3CWebSocket(socketUrl)
      clientRef.current = asrWS
      asrWS.onopen = function () {
        console.log("Websocket 连接成功，开始识别")
        asrWS.send(JSON.stringify({
          "header": {
            "appid": "demo",
            "type": "StartTranscription"
          },
          "payload": {
            "format": "pcm",
            "domain": "general",
            "language": "cn",
            "vocabulary_id": null,
            "lm_id": null,
            "enable_punctuation": false,
            "enable_itn": false,
            "remove_disfluency": false,
            "enable_speaker_info": false,
            "nbest": 1,
            "show_words": true,
            "show_confidence": false,
            "show_intermediate_result": true,
            "enable_semantic_sentence_detection": false,
            "special_word_filter": null
          }
        }))
      }
      asrWS.onmessage = function (_msg) { parseResult(_msg.data) }
      asrWS.onclose = function () {
        console.log("WebSocket 连接断开")
        if (result.length > 0) {
          setInput(result)
          result = ""
        }
      }
      asrWS.onerror = function () { console.log("WebSocket 连接失败") }
    }
  }

  function parseResult(data) {
    let res = JSON.parse(data)
    if (res.header.type == 'SentenceChanged') {
      let sentence = res.payload.result[0].text
      if (sentence.length > 0) {
        setInput(result + sentence)
      }
    } else if (res.header.type == 'SentenceEnd') {
      let sentence = res.payload.result[0].text
      if (sentence.length > 0) {
        result += sentence + '|'
        setInput(result)
      }
      console.log(res)
    }
  }

  function TransferUpload(number, blobOrNull, duration, blobRec, isClose) {
    if (blobOrNull) {
      var blob = blobOrNull
      var encTime = blob.encTime
      var reader = new FileReader()
      reader.onloadend = function () {
        asrWS.send(reader.result)
      }
      reader.readAsArrayBuffer(blob)
    }
  }

  const startRecording = () => {
    SoundRecognizer.init({
      soundType: 'pcm',
      sampleRate: 16000,
      translerCallBack: TransferUpload
    })
    openWebSocket()
  }

  const stopRecording = () => {
    clientRef.current.send(JSON.stringify({
      "header": {
        "appid": "demo",
        "type": "StopTranscription"
      }
    }))
    SoundRecognizer.recordClose()
  }


  const handleChangeTab = (e: React.SetStateAction<string>) => {
    // setActiveKey(e)
    // if (e === 'file') {
    //     setRecordingType('noFlowType')
    // }
  }
  const downloadText = () => {
    if (!input) return
    // 创建 Blob 对象
    const blob = new Blob([input], { type: 'text/plain' });
    // 创建下载链接
    const url = URL.createObjectURL(blob);
    // 创建并点击下载链接
    const a = document.createElement('a');
    a.href = url;
    a.download = `识别结果-${Date.now()}.txt`;
    document.body.appendChild(a);
    a.click();

    // 清理 URL 对象和链接元素
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
  return (
    <>
      {contextHolder}
      <DescribeDiv>
        {ASRDescribeData?.map((item, index) => {
          return < Describe data={item} index={index} />
        })}
      </DescribeDiv>
      <SoundFrame>
        <Container>
          <SoundContainer>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 3 }}>
              <SoundTitle>识别结果</SoundTitle>
              <Download onClick={downloadText}>
                <Tooltip placement="top" title={'保存识别结果'}>
                  <DownloadOutlined />
                </Tooltip>
              </Download>
            </div>
            <TextDiv>
              {input ? input : <span style={{ color: '#999999' }}>还没有内容，快点击按钮试试吧~</span>}
            </TextDiv>
          </SoundContainer>
          <SourceAudioContainer>
            <SoundTitle>语音识别模式</SoundTitle>
            <SensitiveDataConsent checked={sensitiveConsent} onChange={setSensitiveConsent} description="为使用语音识别功能处理我录制或上传的语音文件" />
            <TabbedContent tabs={
              [
                {
                  name: 'record', label: "流式", content: <div style={{ height: 406, background: '#F6F6F6' }}>
                    <>{<AudioRecorder disabled={!isLogin || minorMode || !sensitiveConsent} tab={'recognition'} start={startRecording} stopRecord={stopRecording} onAudioRecorded={HandleAudioRecorded} tabsName={isTabs} />}</>
                  </div>
                },
                {
                  name: 'file', label: "文件上传", content: <> <div style={{ height: 476, background: '#F6F6F6' }}>
                    <BigFileDragger disabled={!isLogin || minorMode || !sensitiveConsent} setInput={setInput} />
                  </div></>
                }
              ]
            } />
          </SourceAudioContainer>
        </Container>
      </SoundFrame >
      <Login></Login>
    </>
  )
}
const DescribeDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    margin-top: 60px;
    height: 198px;
`

const Download = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const TextDiv = styled.div`
  width: 470px;
  height: 516px;
  position: relative;
  margin-top: 12px;
  border: 1px solid #E5E5E5;
    border-radius: 2px;
    padding: 20px;
    line-height: 22px;
    word-wrap: break-word; 
    overflow-wrap: break-word;
    overflow: hidden;
    overflow-y: auto;
    letter-spacing: 1.5px;
`

const SourceAudioContainer = styled.div`
//   background-color: lightgreen;
  width: 470px;
  /* height: 450px; */
  border-radius: 2px;
  /* padding: 20px; */
  /* line-height: 10px; */
  margin:0 0px 0 20px;

`

const SoundCardContainer = styled.div`
  min-height: 90%;
  max-height: 90%;
  overflow-x: clip !important;
`


const SoundTitle = styled.span`
  font-size: 16px;
  color: #222222;
  line-height: 16px;
  font-weight: 600;

`
const SoundContainer = styled.div`
//   background-color: lightblue;
width: 470px;
  /* padding: 20px 0 20px 20px; */
`
const Container = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  /* grid-gap: 10px; */
`
const SoundFrame = styled.div`
  width: 100%;
  /* height: 550px; */
  background: #FFFFFF;
  box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
//   margin-top: 60px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`
